"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLoginBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateLoginBody = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
    password: (0, validation_1.text)(),
});
//# sourceMappingURL=LoginBody.js.map